import { SelectProps } from 'antd/lib'

import { useCounterpartServiceGetInternalInstitutionEndpoint } from 'src/api/queries'
import { InternalInstitutionsSelect } from 'src/components'

/**
 * An institution of Form 058-1/e: a legal entity (internal institution), the institutions doctors can search.
 * Stores only the id and shows the name of a saved id even when it is not on the loaded page of options.
 */
export const HivInstitutionSelect = (props: SelectProps<string>) => {
  const { value } = props

  const { data: institution } =
    useCounterpartServiceGetInternalInstitutionEndpoint(
      { id: String(value) },
      [value],
      { enabled: !!value, retry: false }
    )

  const initialOptions =
    institution?.id && institution.id === value
      ? [{ value: institution.id, label: String(institution.name) }]
      : undefined

  return (
    <InternalInstitutionsSelect {...props} initialOptions={initialOptions} />
  )
}
